import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SuiContainer, SuiCheckbox } from '@splashthat/sui';

import {
    NODE_NAME_UTM_SOURCE,
    NODE_NAME_UTM_MEDIUM,
    NODE_NAME_UTM_CAMPAIGN,
    NODE_NAME_UTM_TERM,
    NODE_NAME_UTM_CONTENT,
} from 'common/entities/formNode/nodeNames';

import { getChildrenFromNodeId } from 'common/entities/formNode/selectors';
import { INPUT_TYPE_HIDDEN } from 'common/entities/formNode/inputTypes';
import { NODE_TYPE_QUESTION } from 'common/entities/formNode/nodeTypes';
import { removeFormNode, createFormNode } from '../../../actions/nodeActions';
import { getEditFormNodeId } from '../../../selectors';
import disableWhenLocked from './disableWhenLocked';

const LABELS = {
    [NODE_NAME_UTM_SOURCE]: 'Source (utm_source)',
    [NODE_NAME_UTM_MEDIUM]: 'Medium (utm_medium)',
    [NODE_NAME_UTM_CAMPAIGN]: 'Campaign (utm_campaign)',
    [NODE_NAME_UTM_TERM]: 'Term (utm_term)',
    [NODE_NAME_UTM_CONTENT]: 'Content (utm_content)',
};

const FAKE_UTM_NODES = {
    [NODE_NAME_UTM_SOURCE]: {
        id: '_NEW_UTM_SOURCE_',
        type: NODE_TYPE_QUESTION,
        name: NODE_NAME_UTM_SOURCE,
        label: 'utm_source',
        inputType: INPUT_TYPE_HIDDEN,
        urlParamName: 'utm_source',
    },
    [NODE_NAME_UTM_MEDIUM]: {
        id: '_NEW_UTM_MEDIUM_',
        type: NODE_TYPE_QUESTION,
        name: NODE_NAME_UTM_MEDIUM,
        label: 'utm_medium',
        inputType: INPUT_TYPE_HIDDEN,
        urlParamName: 'utm_medium',
    },
    [NODE_NAME_UTM_CAMPAIGN]: {
        id: '_NEW_UTM_CAMPAIGN_',
        type: NODE_TYPE_QUESTION,
        name: NODE_NAME_UTM_CAMPAIGN,
        label: 'utm_campaign',
        inputType: INPUT_TYPE_HIDDEN,
        urlParamName: 'utm_campaign',
    },
    [NODE_NAME_UTM_TERM]: {
        id: '_NEW_UTM_TERM_',
        type: NODE_TYPE_QUESTION,
        name: NODE_NAME_UTM_TERM,
        label: 'utm_term',
        inputType: INPUT_TYPE_HIDDEN,
        urlParamName: 'utm_term',
    },
    [NODE_NAME_UTM_CONTENT]: {
        id: '_NEW_UTM_CONTENT_',
        type: NODE_TYPE_QUESTION,
        name: NODE_NAME_UTM_CONTENT,
        label: 'utm_content',
        inputType: INPUT_TYPE_HIDDEN,
        urlParamName: 'utm_content',
    },
};

const UtmParamsControl = (props) => {
    const getNodeByName = (name) => props.childrenNodes.find((node) => node.name === name);

    const handleOnChange = (node, key, index) => {
        if (node) {
            return props.removeFormNode(node.id);
        }
        return props.createFormNode(FAKE_UTM_NODES[key], props.formNodeId, index);
    };

    const utmNodes = {
        [NODE_NAME_UTM_SOURCE]: getNodeByName(NODE_NAME_UTM_SOURCE),
        [NODE_NAME_UTM_MEDIUM]: getNodeByName(NODE_NAME_UTM_MEDIUM),
        [NODE_NAME_UTM_CAMPAIGN]: getNodeByName(NODE_NAME_UTM_CAMPAIGN),
        [NODE_NAME_UTM_TERM]: getNodeByName(NODE_NAME_UTM_TERM),
        [NODE_NAME_UTM_CONTENT]: getNodeByName(NODE_NAME_UTM_CONTENT),
    };

    return (
        <SuiContainer variation="padded-lean flex-vertical">
            {Object.keys(utmNodes).map((objKey, index) => (
                <SuiCheckbox
                    key={objKey}
                    label={LABELS[objKey]}
                    checked={!!utmNodes[objKey]}
                    disabled={props.disabled}
                    onChange={() => handleOnChange(utmNodes[objKey], objKey, index)}
                />
            ))}
        </SuiContainer>
    );
};

UtmParamsControl.propTypes = {
    formNodeId: PropTypes.string.isRequired,
    childrenNodes: PropTypes.arrayOf(PropTypes.object).isRequired,
    removeFormNode: PropTypes.func.isRequired,
    createFormNode: PropTypes.func.isRequired,
    /** disabled is passed when form node editing is locked */
    disabled: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    const editFormNodeId = getEditFormNodeId(state);
    const childrenNodes = editFormNodeId ? getChildrenFromNodeId(state, editFormNodeId) : [];

    return {
        childrenNodes,
    };
};

const mapDispatchToProps = {
    removeFormNode,
    createFormNode,
};

export default connect(mapStateToProps, mapDispatchToProps)(disableWhenLocked(UtmParamsControl));
